











import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

const OPEN = {
  type: 'open',
  label: 'dashboard.labels.open',
  icon: '',
  background: 'green',
};
const VARIABLE_PRICING = {
  type: 'variable-pricing',
  label: 'dashboard.labels.variablePricing',
  icon: '',
  background: 'variable-pricing-legend',
};
const STOP_SALE = {
  type: 'stop-sale',
  label: 'dashboard.labels.stopSale',
  icon: 'ban',
  background: 'red',
};
const SOLD_OUT = {
  type: 'sold-out',
  label: 'dashboard.labels.soldOut',
  icon: 'exclamation',
  background: 'green',
};
const SOLD_OUT_VARIABLE_PRICING = {
  type: 'sold-out',
  label: 'dashboard.labels.soldOut',
  icon: '',
  background: 'yellow',
};

@Component({
  computed: mapState({
    isOnRequest: (state: any) => state.dashboard.isOnRequest,
  }),
})
export default class DashboardAnnonate extends Vue {
  private readonly isOnRequest!: boolean;
  public get annonates() {
    if (!(process.env.VUE_APP_VARIABLE_PRICING_ENABLED === '1' && Vue.prototype.$PARTNER_HAS_VARIABLE_PRICING)) {
      return this.isOnRequest
          ? [OPEN, STOP_SALE]
          : [OPEN, SOLD_OUT, STOP_SALE];
    } else {
      return this.isOnRequest
          ? [OPEN, VARIABLE_PRICING, STOP_SALE]
          : [OPEN, VARIABLE_PRICING, SOLD_OUT_VARIABLE_PRICING, STOP_SALE];
    }
  }
}
